module.exports = __webpack_public_path__ + "static/media/pMeterBG.10088bf1.svg";